import AService from '@/services/AService';

const ENTITY_NAME = 'venues';

export default class VenueService extends AService {

  /**
   * Gets all venues sorted and paged
   * @return {Promise<VenueDto[]>}
   */
  async fetchVenuesPagingAndSorting(params) {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/pagingAndSorting`, {params})
    return response.data;
  }

  /**
   * Gets a venue with its id
   * @return {Promise<VenueDto>}
   */
  async fetchVenue(venueId) {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/${venueId}`)
    return response.data
  }

  /**
   * Creates a venue
   * @return {Promise<VenueDto>}
   */
  async createVenue(data) {
    const response = await this.http.post(`${this.baseUrl}/${ENTITY_NAME}`, data);
    return response.data;
  }

  /**
   * Updates an venue
   * @return {Promise<VenueDto>}
   */
  async updateVenue(data) {
    const response = await this.http.put(`${this.baseUrl}/${ENTITY_NAME}`, data);
    return response.data
  }

  /**
   * Deletes an venue
   * @return {Promise<VenueDto>}
   */
  async deleteVenue(id) {
    const response = await this.http.delete(`${this.baseUrl}/${ENTITY_NAME}/${id}`)
    return response.data
  }

  /**
   * Activates venue
   * @param id
   * @returns {Promise<VenueDto>}
   */
  async activateVenue(id) {
    const response = await this.http.put(`${this.baseUrl}/${ENTITY_NAME}/activate/${id}`);
    return response.data
  }

  /**
   * Deactivates venue
   * @param id
   * @returns {Promise<VenueDto>}
   */
  async deactivateVenue(id) {
    const response = await this.http.put(`${this.baseUrl}/${ENTITY_NAME}/deactivate/${id}`);
    return response.data
  }
}
